import BaseRepository from '@/api/repositories/BaseRepository';
import { toLocalDateString } from '@/helpers/Utils.js';

export default class DamageAssessorCaseRepository extends BaseRepository {
	getAllCases(scope, perPage, page, search) {
		return this.get('damage-assessor-cases', {
			scope,
			per_page: perPage,
			page,
			search: search?.trim() || undefined,
		});
	}

	getBrokerCases() {
		return this.get(`damage-assessor-cases/unclaimed-broker-cases`, {});
	}
	getDeclinedCases() {
		return this.get(`damage-assessor-cases/declined-broker-cases`, {});
	}
	getBrokerCaseDetail(id) {
		return this.get(`damage-assessor-cases/broker-cases/${id}`, {});
	}
	getDamageAssessorCaseDetail(id) {
		return this.get(`damage-assessor-cases/${id}`, {});
	}
	claimBrokerCase(id) {
		return this.post(`damage-assessor-cases/claim`, {}, { broker_case_id: id });
	}
	setAppointment(id, date) {
		return this.post(`damage-assessor-cases/${id}/appointment`, {}, { appointment_agreed_at: toLocalDateString(date) });
	}
	setExaminationDate(id, date) {
		return this.post(`damage-assessor-cases/${id}/examined`, {}, { examined_at: toLocalDateString(date) });
	}
	closeDamageAssessorCase(id) {
		return this.post(`damage-assessor-cases/${id}/close`, {}, {});
	}
	closeBrokerCase(id) {
		return this.post(`damage-assessor-cases/broker-cases/${id}/close`, {}, {});
	}
	getCompensations(month, year, assessorId, compensated) {
		return this.get(`compensations/candidates`, { month: month, year: year, assessor_id: assessorId, compensated: compensated });
	}
	getCompanyEmployees(id) {
		return this.get(`company/${id}/employees`, {});
	}
	swapDamageAssessor(id, damageAssessorId) {
		return this.post(`damage-assessor-cases/${id}/swap`, { damage_assessor_id: damageAssessorId });
	}
	closeCompensation(data) {
		return this.post(`compensations`, {}, data);
	}
	downloadFileForCompensation(id) {
		return this.get(`compensations/${id}/download`, {});
	}
	updateCompensation(id, data) {
		return this.put(`compensations/${id}/update`, {}, data);
	}

	createDamageAssessorCase(data) {
		return this.post(`damage-assessor-cases`, {}, data);
	}

	updateDamageAssessorCase(id, data) {
		return this.put(`damage-assessor-cases/${id}`, {}, data);
	}

	updateAccidentData(id, data) {
		return this.put(`damage-assessor-cases/${id}`, {}, data);
	}
	getExpertiseDocument(id) {
		return this.get(`damage-assessor-cases/${id}/expertise-document`, {});
	}

	getLawyerOffices() {
		return this.get(`damage-assessor-cases/lawyer-offices`, {});
	}
}
